import { getRouteApi } from '@tanstack/react-router';
import { useCallback } from 'react';

import { BroadcastsScreen } from './BroadcastsScreen';
import type { BroadcastsSearch } from './broadcasts-search';

const route = getRouteApi('/broadcasts');

export function BroadcastsRoute() {
  const search = route.useSearch();
  const navigate = route.useNavigate();
  const onSearchChange = useCallback(
    (next: BroadcastsSearch) => {
      void navigate({ replace: true, search: () => next });
    },
    [navigate],
  );
  return <BroadcastsScreen search={search} onSearchChange={onSearchChange} />;
}
